
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-events/all",
      function () {
        return require("private-next-pages/news-and-events/all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-events/all"])
      });
    }
  